import React, { useEffect, useState } from "react";
import queryString from "query-string";

import {
    CALCULATOR_KEYS,
    trackCalculatorStepStarted,
    trackCalculatorStepSubmitted,
} from "@services/tracking";

import Calculation from "./calculation/calculation.component";
import Result from "./result/result.component";

const WallpaperCalculator = () => {
    const [wallArea, setWallArea] = useState(0);
    const [windowArea, setWindowArea] = useState(0);
    const [doorArea, setDoorArea] = useState(0);
    const [rollArea, setRollArea] = useState(0);

    const [roll, setRoll] = useState([0, 0]);
    const [walls, setWalls] = useState([[0, 0]]);
    const [windows, setWindows] = useState([[0, 0]]);
    const [doors, setDoors] = useState([[0, 0]]);

    useEffect(() => {
        trackCalculatorStepStarted(CALCULATOR_KEYS.wallpaper);
    }, []);

    useEffect(() => {
        if (wallArea || windowArea || doorArea || rollArea) {
            // @ts-ignore
            trackCalculatorStepSubmitted(CALCULATOR_KEYS.wallpaper);
        }
    }, [wallArea, windowArea, doorArea, rollArea]);

    useEffect(() => {
        const q = queryString.parse(location.search);
        
        q.walls && setWalls((q.walls as string).split(',').map((x) => x.split('_').map((i) => Number(i))));
        q.doors && setDoors((q.doors as string).split(',').map((x) => x.split('_').map((i) => Number(i))));
        q.windows && setWindows((q.windows as string).split(',').map((x) => x.split('_').map((i) => Number(i))));
        q.roll && setRoll((q.roll as string).split(',').map((i) => Number(i)));
    }, [])

    const calculationProps = {
        calculateWallArea: (area: number) => setWallArea(area),
        calculateWindowArea: (area: number) => setWindowArea(area),
        calculateDoorArea: (area: number) => setDoorArea(area),
        calculateRollArea: (area: number) => setRollArea(area),
        walls,
        doors,
        windows,
        roll,
        setWalls,
        setDoors,
        setWindows,
        setRoll,
    };

    const resultProps = {
        wallArea: wallArea,
        windowArea: windowArea,
        doorArea: doorArea,
        rollArea: rollArea,
        mailParams: {
            walls: walls.reduce((acc, wall) => [...acc, wall.join('_')], [] as string[]).join(','),
            windows: windows.reduce((acc, window) => [...acc, window.join('_')], [] as string[]).join(','),
            doors: doors.reduce((acc, door) => [...acc, door.join('_')], [] as string[]).join(','),
            roll: roll.join(','),
        },
    };

    return (
        <div id="calculator">
            <Calculation {...calculationProps} />
            <Result {...resultProps} />
        </div>
    );
};

export { WallpaperCalculator };
